export var QueueProcessor = (function() {
    "use strict";

    //var pIndex = 0;
    //var forceStop = false;
    //var resolve = null;

    function QueueProcessor() {
        this.resolve = null;
        this.forceStop = false;
        this.pIndex = -1;
        this.processes = [];
    }

    QueueProcessor.prototype.process = function() {
        //var _this = this;

        this.pIndex++;

        if(this.forceStop) {
            return false;
        }

        if(typeof this.processes[this.pIndex] === "undefined") {
            (!this.forceStop && this.resolve) && this.resolve();
            return;
        }

        this.processes[this.pIndex]().then(function () {

            if(!this.forceStop) {
                this.process.call(this);
            }


        }.bind(this));
    };


    QueueProcessor.prototype.add = function(func) {
        this.processes.push(func);
    };

    QueueProcessor.prototype.run = function() {
        var _this = this;
        this.pIndex = -1;
        this.forceStop = false;
        return new Promise(function(res, rej) {
            _this.resolve = res;
            _this.process.call(_this);
        });
    };

    QueueProcessor.prototype.stop = function() {
        this.forceStop = true;
    };

    QueueProcessor.prototype.clear = function() {
        this.pIndex = -1;
        this.processes = [];
    };

    return QueueProcessor;

}());